import { styled } from 'styled-components';

import type { AppConfig } from '#/config/types/AppConfig';
import { cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';
import { imageUrl } from '#/utils/filestack';
import { hiDPI } from '#/utils/style';

export const CmsSignUpBlockHolder = styled.div<{
  $imageHandle: string | undefined;
  $mimetype: string | undefined;
  $appConfig: AppConfig;
}>`
  background-size: cover;
  background-position: center;
  ${({ $imageHandle, $mimetype, $appConfig: appConfig }) =>
    $imageHandle &&
    `
    background-image: url('${imageUrl({
      data: {
        handle: $imageHandle,
        mimetype: $mimetype,
      },
      width: 800,
      height: undefined,
      fit: 'max',
      insecureSVG: false,
      appConfig,
    })}');
    ${hiDPI()}: {
      background-image: url('${imageUrl({
        data: { handle: $imageHandle, mimetype: $mimetype },
        width: 1600,
        height: undefined,
        fit: 'max',
        insecureSVG: false,
        appConfig,
      })}');
    }
    @media all and (min-width: ${cssBreakpoints.lgUp}) {
      background-image: url('${imageUrl({
        data: { handle: $imageHandle, mimetype: $mimetype },
        width: 1280,
        height: undefined,
        fit: 'max',
        insecureSVG: false,
        appConfig,
      })}');
      ${hiDPI()}: {
        background-image: url('${imageUrl({
          data: { handle: $imageHandle, mimetype: $mimetype },
          width: 2560,
          height: undefined,
          fit: 'max',
          insecureSVG: false,
          appConfig,
        })}');
      }
    }
  `}
`;

export const CmsSignUpBlock_Box_1 = styled.div`
  width: 100%;
  padding-block: ${gutterWidth / 2}px;
  padding-inline: ${gutterWidth / 2}px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 0 6px rgb(0 0 0 / 0.3);

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    border-radius: 0;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
    border-radius: 12px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding-block: 32px;
    padding-inline: ${gutterWidth}px;
  }
`;

export const CmsSignUpBlock_Box_2 = styled.div`
  padding-top: 58px;
  padding-bottom: 58px;
  padding-inline: 24px;
  margin-inline: auto;
  max-width: ${maxWidth[3]}px;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-top: ${gutterWidth / 2}px;
    padding-bottom: ${gutterWidth / 2}px;
    padding-inline: ${gutterWidth / 2}px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding-top: 52px;
    padding-bottom: 96px;
    padding-inline: ${gutterWidth}px;
  }
`;
